// extracted by mini-css-extract-plugin
module.exports = {"loading":"_3BjkB","stretch":"_1lLpg"};